
import { Action } from 'vuex-class';
import { Vue, Component, Watch } from "vue-property-decorator";
import TaLayoutHeader from "@/components/shared/layout/TaLayoutHeader.vue";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import InfoModal from "@/plugins/notification/infoModal";
import { CheckAuthInput, CheckAuthOutput } from "@fubonlife/tacallindiy-core-axios-sdk";
import LayoutFooter from '@/components/shared/layout/FblLayoutFooter.vue';


@Component({ components: { TaLayoutHeader, LayoutLoading, LayoutFooter } })
export default class Login extends Vue {
	@Action('setLoading') setLoading;

	// 欄位
	form: CheckAuthInput = {
		custId: "",
		mobile: "",
	};

	// 自定義檢核狀態(antd-vue 驗證有4種狀態: error、success、warning、validating)
	validStatus: { [key: string]: string } = {
		custId: "",
		mobile: "",
	};

	// 自定義錯誤訊息
	customErrorMsg: { [key: string]: string } = {
		custId: "",
		mobile: "",
	};

	created() {
		this.$user.signOut();
		var notice = this.$route.query.notice as string;
		if (notice && notice === 'Y') {
			InfoModal.alertModal({
				alertType: "warning",
				title: "提醒",
				content: "原網址已停止使用，請至新網址：https://gpta.fubonlife.com.tw/cdiy-web/login 進行預約投保。",
				customContent: null,
			});
		}
	}

	// 頁面橫幅
	imgRwd: string = "image_callin_desktop";
	screenWidth: number = 0;

	// 取得畫面寬度
	mounted() {
		this.screenWidth = document.body.clientWidth;

		window.onresize = () => {
			return (() => {
				this.screenWidth = document.body.clientWidth;
			})();
		};
	}
	// 載入橫幅 & 下拉式選單字體大小
	@Watch('screenWidth')
	widthChange() {
		if (this.screenWidth <= 500) {
			this.imgRwd = 'image_callin_mobile';
		} else if (500 < this.screenWidth && this.screenWidth <= 1024) {
			this.imgRwd = 'image_callin_tablet';
		} else {
			this.imgRwd = 'image_callin_desktop';
		}
	}

	// 手動觸發 antd FormModel 驗證
	triggerValidate(field: string, msg?: string) {
		if (msg) {
			this.validStatus[field] = "error";
			this.customErrorMsg[field] = msg;
		} else {
			this.validStatus[field] = "success";
			this.customErrorMsg[field] = "";
		}
	}

	// 前端檢核規則-身分證字號/居留證號
	checkCustId(value: string) {
		if (!value) {
			return "請輸入有效身分證字號";
		}
		if (!/^[A-Z0-9]{10}$/.test(value)) {
			return "請輸入完整之身分證字號";
		}
	}

	checkValidCustId(custId) {
		this.triggerValidate("custId", this.checkCustId(custId));
		if (this.validStatus.custId === "error") {
			return;
		}
	}

	// 前端檢核規則-驗證碼
	checkMobile(value: string) {
		if (!value) {
			return "請輸入有效手機號碼";
		}
		if (!/^09[0-9]{8}$/g.test(value)) {
			return "請輸入完整手機號碼";
		}
	}

	checkValidMobile(mobile) {
		this.triggerValidate("mobile", this.checkMobile(mobile));
		if (this.validStatus.mobile === "error") {
			return;
		}
	}

	async handleBeforeSubmit() {
		// 前端檢核
		const custIdHasError = this.checkCustId(this.form.custId);
		const mobileHasError = this.checkMobile(this.form.mobile);
		if (!custIdHasError && !mobileHasError) {
			this.setLoading(true)
			this.$CustomerControllerApi.chkIdAndMobleUsingPOST1(this.form)
				.then(res => {
					if (res.status === 200) {
						var result: CheckAuthOutput = JSON.parse(JSON.stringify(res.data));
						switch (result.returnCode) {
							case '01':
								// 驗證成功
								this.$router.replace({
									name: "OTPVerify",
									params: {
										custId: result.custId,
										mobile: result.mobile
									},
								});
								break;

							case '02':
								// Callin要保人ID，但非約定手機號碼
								InfoModal.alertModal({
									alertType: "error",
									title: "錯誤",
									content: "輸入的手機號碼，非Call in卡約定之手機號碼，請重新輸入。",
									customContent: null,
								});
								break;

							case '03':
								// 非Callin要保人ID
								this.$router.replace({ name: "Error03" });
								break;

							case '04':
								// 與Call-in要保人ID與手機號碼一致，但不符合目前可DIY條件
								this.$router.replace({ name: "Error04" });
								break;

							case '05':
								// 系統維護中
								this.$router.replace({ name: "ErrorMaintenance" });
								break;
						}
					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: "系統發生錯誤，請重新嘗試。",
							customContent: null,
						});
					}
				})
				.finally(() => {
					this.setLoading(false);
				})
		} else {
			this.triggerValidate("custId", custIdHasError);
			this.triggerValidate("mobile", mobileHasError);
		}
	}
}
